import { useContext, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import AuthContext from '../../store/AuthContext';
import {HeaderContext, ResultMode} from '../../store/HeaderContext';
import AccountService from "../../services/AccountService"
import { BsSearch } from 'react-icons/bs';
import { FaMapMarkedAlt, FaThList, FaBars, FaRegUserCircle } from 'react-icons/fa';
import { Container, Row, Col, InputGroup, FormControl, Button, ButtonGroup, ToggleButton} from 'react-bootstrap';
import MainMenuMobile from './MainMenuMobile'
import NativeInterface from "services/NativeInterface"
import { LuCog } from "react-icons/lu";

import "./HeaderMobile.css"

const HeaderMobile: React.FC = () => {
    const authCtx = useContext(AuthContext);
    const headerCtx = useContext(HeaderContext);
    let navigate = useNavigate();
    const [activeMenu, setActiveMenu] = useState(false);
    
    function toggleMenu() {
        setActiveMenu(prevActive => !prevActive);
    }

    function loginClickHandler() {
        navigate("/account");
    }

    function logoutClickHandler() {
        toggleMenu();
        AccountService.logout();
        navigate("/account");
    }

    const isAndroid = (): boolean => /Android/i.test(navigator.userAgent);
    const isIOS = (): boolean => /iPhone|iPad/i.test(navigator.userAgent);

return (
    <>
        <div className="header-mobile-main">
            <div className="header-mobile-left-container">
                <Link to="/">
                    <img src="./img/logo.png" alt="logo" style={{ width: '160px' }} />
                </Link>
            </div>
            {!NativeInterface.isPWA() &&
                <div className="header-mobile-mid-container">
                {isAndroid() &&
                    <a href="https://play.google.com/store/apps/details?id=world.dimx.app" target="_blank">
                        <img src="img/google_play.png" className="header-mobile-download-button"/>
                    </a>
                }
                {isIOS() &&
                        <a href="https://apps.apple.com/us/app/dimensionx-app/id1540590200" target="_blank">
                        <img src="img/apple_appstore.png" className="header-mobile-download-button"/>
                    </a>
                }
                </div>
            }
            <div className="header-mobile-right-container">
                {authCtx.account.studio.enabled &&
                    <NavLink to="/own-dimensions">
                        <LuCog size={32} style={{ marginRight: '10px'}}/>
                    </NavLink>
                }
                {/*
                <Button variant="outline-info" className="d-flex justify-content-center align-items-center" onClick={toggleMenu}>
                    <FaBars size={22}/>
                </Button>
                */}
            </div>
        </div>
        <MainMenuMobile isOpen={activeMenu} onClose={toggleMenu}/>
    </>
  );
};

export default HeaderMobile;
